import {GetItemCounts, useInfiniteReferralsSent} from "@twigsby/client-data";
import {
    ContentBlock,
    ContentLoader,
    FlexAlign,
    FlexJustify, InfiniteLoadTrigger, ItemRow, ItemRowHeader, RichEmptyState,
    StackHorizontal,
} from "@twigsby/frontend-framework";
import {FormatLocaleDateTime} from "@twigsby/helpers";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {CommissionImage} from "../../../Components/Images/CommissionImage";
import {MailBoxImage} from "../../../Components/Images/MailboxImage";
import {useSite} from "../../../Providers/SiteInterfaceProvider";

const ReferralsSent = () => {
    const { t } = useTranslation();
    const { currentLocale, updatePageMeta } = useSite();

    const {
        data,
        status,
        error,
        dataUpdatedAt,
        hasNextPage,
        fetchNextPage,
        isFetchingNextPage
    } = useInfiniteReferralsSent();

    const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 } );

    const referralsSentRef = useRef<any>();

    useEffect(() => {
        if(data) {
            setItemCounts(GetItemCounts(data as any));
        }
    }, [dataUpdatedAt, data]);

    useEffect(() => {
        updatePageMeta({
            title: t(`settings.sections.${"Referrals Sent"}`)
        });
    }, [currentLocale]);

    return (
        <>
            <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-xs'}>
                <h2 className={'mb-0'}>{t(`settings.sections.${"Referrals Sent"}`)}</h2>
            </StackHorizontal>

            <div className={'card commissions-sent-rows'} ref={referralsSentRef}>
                <ItemRowHeader sticky={true}>
                    <div>{t('settings.referralsSent.headings.email')}</div>
                    <div>{t('settings.referralsSent.headings.signedUp')}</div>
                    <div>{t('settings.referralsSent.headings.dateReminderSent')}</div>
                    <div>{t('settings.referralsSent.headings.dateSent')}</div>
                </ItemRowHeader>

                {status === "loading" ? (
                    <ContentLoader childHeight={'5em'} childCount={10}/>
                ) : status === "error" ? (
                    <ContentBlock error={true} stacked={true} title={error?.name} content={error?.message} />
                ) : (
                    <>
                        {data.pages.map((group, groupIndex) => {
                            if(group.totalRecords === 0) {
                                return (
                                    <RichEmptyState
                                        title={t('settings.referralsSent.noData.title')}
                                        description={t('settings.referralsSent.noData.description')}
                                        media={<CommissionImage />}
                                    />
                                )
                            }

                            return (
                                <>
                                    {group.data.map((commissionEntry, index) => {
                                        return (
                                            <ItemRow
                                                key={`commissionEntry${index}`}
                                                static={true}
                                            >
                                                <div>{commissionEntry.emailAddress}</div>
                                                <div>{commissionEntry.signedUp}</div>
                                                <div>{FormatLocaleDateTime(commissionEntry.reminderSent, currentLocale)}</div>
                                                <div>{FormatLocaleDateTime(commissionEntry.dateSent, currentLocale)}</div>
                                            </ItemRow>
                                        )
                                    })}
                                </>
                            )
                        })}

                        {itemCounts.total > 0 && (
                            <InfiniteLoadTrigger
                                loaded={itemCounts.loaded}
                                totalCount={itemCounts.total}
                                hasNextPage={hasNextPage}
                                fetchNextPage={fetchNextPage}
                                isFetchingNextPage={isFetchingNextPage}
                            />
                        )}
                    </>
                )}
            </div>
        </>
    )
}

export { ReferralsSent }
